/**
 * PasswordReset saga functions
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';

const { Auth } = Constants;

/**
 * Logs in user and dispatches success or error
 *
 * @param {object} action:
 * {
 *   @property {string} email: user email
 *   @property {string} password: user password
 * }
 */
export function* login({ email, password, token2FA, method2FA }) {
  try {
    const token = yield call(
      UserAPI.login,
      email,
      password,
      token2FA,
      method2FA,
    );
    if (token.required2FA) {
      yield put(Actions.login2FARequired(token));
    } else {
      yield put(Actions.loginSuccess(token));
    }
  } catch (err) {
    yield put(Actions.loginError(err));
  }
}

/**
 * Gets the response of the latest login request
 */
function* loginSaga() {
  yield takeLatest(Auth.LOGIN, login);
}

export default loginSaga;
